export function getdata() {
	var obj = {

		headDataI: [{
			title: '汇总纳税企业增值税分配表-总机构信息',
			children: [{
					title: '',
					prop: 'title_one',
					width: "300px",
					custom: true,
				},
				{
					title: "",
					prop: 'zzs_8_x_1',
					width: "300px",
					custom: true,
				}, {
					title: "",
					prop: 'title_two',
					width: "300px",
					custom: true,
				}, {
					title: "",
					prop: 'zzs_8_x_2',
					width: "300px",
					custom: true,
				}, {
					title: "",
					prop: 'title_three',
					width: "300px",
					custom: true,
				}, {
					title: "",
					custom: true,
					prop: "zzs_8_x_3",
					width: "200px",
				}
			]
		}],
		headDataII: [{
			title: '纳税人识别号',
			custom: true,
			prop: "zzs_8_x_1",
			width: "200px",
		}, {
			title: '纳税人名称',
			custom: true,
			prop: "zzs_8_x_2",
			width: "200px",
		}, {
			title: '分支机构一般货物及劳务',
			children: [{
				title: '销售收入',
				custom: true,
				prop: "zzs_8_x_3",
				width: "200px",
			}, {
				title: '分配比例',
				custom: true,
				prop: "zzs_8_x_4",
				width: "200px",
			}, {
				title: '分配税额',
				custom: true,
				prop: "zzs_8_x_5",
				width: "200px",
			}]
		}, {
			title: '分支机构一般货物及劳务即征即退',
			children: [{
				title: '销售收入',
				custom: true,
				prop: "zzs_8_x_6",
				width: "200px",
			}, {
				title: '分配比例',
				custom: true,
				prop: "zzs_8_x_7",
				width: "200px",
			}, {
				title: '分配税额',
				custom: true,
				prop: "zzs_8_x_8",
				width: "200px",
			}]
		}, {
			title: '分支机构应税服务',
			children: [{
				title: '销售收入',
				custom: true,
				prop: "zzs_8_x_9",
				width: "200px",
			}, {
				title: '分配比例',
				custom: true,
				prop: "zzs_8_x_10",
				width: "200px",
			}, {
				title: '分配税额',
				custom: true,
				prop: "zzs_8_x_11",
				width: "200px",
			}]
		}, {
			title: '分支机构应税服务即征即退',
			children: [{
				title: '销售收入',
				custom: true,
				prop: "zzs_8_x_12",
				width: "200px",
			}, {
				title: '分配比例',
				custom: true,
				prop: "zzs_8_x_13",
				width: "200px",
			}, {
				title: '分配税额',
				custom: true,
				prop: "zzs_8_x_14",
				width: "200px",
			}]
		}],
		tableDataII: [{
				disabledzzs_8_x_1: false,
				disabledzzs_8_x_2: false,
				disabledzzs_8_x_3: false,
				disabledzzs_8_x_4: false,
				disabledzzs_8_x_5: false,
				disabledzzs_8_x_6: false,
				disabledzzs_8_x_7: false,
				disabledzzs_8_x_8: false,
				disabledzzs_8_x_9: false,
				disabledzzs_8_x_10: false,
				disabledzzs_8_x_11: false,
				disabledzzs_8_x_12: false,
				disabledzzs_8_x_13: false,
				disabledzzs_8_x_14: false,
				zzs_8_x_1: {
					cellCode: "zzs_8_1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_2: {
					cellCode: "zzs_8_1_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_3: {
					cellCode: "zzs_8_1_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_4: {
					cellCode: "zzs_8_1_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_5: {
					cellCode: "zzs_8_1_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_6: {
					cellCode: "zzs_8_1_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_7: {
					cellCode: "zzs_8_1_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_8: {
					cellCode: "zzs_8_1_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_9: {
					cellCode: "zzs_8_1_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_10: {
					cellCode: "zzs_8_1_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_11: {
					cellCode: "zzs_8_1_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_12: {
					cellCode: "zzs_8_1_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_13: {
					cellCode: "zzs_8_1_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_14: {
					cellCode: "zzs_8_1_14",
					cellType: "1",
					cellVal: "240040043.08"
				},

			},
			{
				disabledzzs_8_x_1: false,
				disabledzzs_8_x_2: false,
				disabledzzs_8_x_3: false,
				disabledzzs_8_x_4: false,
				disabledzzs_8_x_5: false,
				disabledzzs_8_x_6: false,
				disabledzzs_8_x_7: false,
				disabledzzs_8_x_8: false,
				disabledzzs_8_x_9: false,
				disabledzzs_8_x_10: false,
				disabledzzs_8_x_11: false,
				disabledzzs_8_x_12: false,
				disabledzzs_8_x_13: false,
				disabledzzs_8_x_14: false,
				zzs_8_x_1: {
					cellCode: "zzs_8_1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_2: {
					cellCode: "zzs_8_1_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_3: {
					cellCode: "zzs_8_1_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_4: {
					cellCode: "zzs_8_1_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_5: {
					cellCode: "zzs_8_1_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_6: {
					cellCode: "zzs_8_1_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_7: {
					cellCode: "zzs_8_1_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_8: {
					cellCode: "zzs_8_1_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_9: {
					cellCode: "zzs_8_1_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_10: {
					cellCode: "zzs_8_1_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_11: {
					cellCode: "zzs_8_1_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_12: {
					cellCode: "zzs_8_1_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_13: {
					cellCode: "zzs_8_1_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_14: {
					cellCode: "zzs_8_1_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}
		],
		tableDataI: [{
				title_one: '总机构纳税人名称',
				title_two: '营业地址',
				title_three: '联系电话',
				disabledzzs_8_x_1: false,
				disabledzzs_8_x_2: false,
				disabledzzs_8_x_3: false,
				zzs_8_x_1: {
					cellCode: "zzs_8_0_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_2: {
					cellCode: "zzs_8_0_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_3: {
					cellCode: "zzs_8_0_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title_one: '法定代表人姓名',
				title_two: '开户银行',
				title_three: '银行账号',
				disabledzzs_8_x_1: false,
				disabledzzs_8_x_2: false,
				disabledzzs_8_x_3: false,
				zzs_8_x_1: {
					cellCode: "zzs_8_1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_2: {
					cellCode: "zzs_8_1_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_3: {
					cellCode: "zzs_8_1_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			},
			{
				title_one: '总机构纳税人识别号',
				title_two: '应补(退)税额',
				title_three: '总分机构销售额合计',
				disabledzzs_8_x_1: false,
				disabledzzs_8_x_2: false,
				disabledzzs_8_x_3: false,
				zzs_8_x_1: {
					cellCode: "zzs_8_2_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_2: {
					cellCode: "zzs_8_2_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_3: {
					cellCode: "zzs_8_2_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			},
			{
				title_one: '总机构固定分配比例',
				title_two: '',
				title_three: '',
				disabledzzs_8_x_1: false,
				disabledzzs_8_x_2: false,
				disabledzzs_8_x_3: false,
				zzs_8_x_1: {
					cellCode: "zzs_8_3_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_2: {
					cellCode: "zzs_8_3_2",
				},
				zzs_8_x_3: {
					cellCode: "zzs_8_3_3",
				},
			},
			{
				title_one: '总机构一般货物及劳务销售收入',
				title_two: '总机构一般货物及劳务分配比例',
				title_three: '总机构一般货物及劳务分配税额',
				disabledzzs_8_x_1: false,
				disabledzzs_8_x_2: false,
				disabledzzs_8_x_3: false,
				zzs_8_x_1: {
					cellCode: "zzs_8_4_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_2: {
					cellCode: "zzs_8_4_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_3: {
					cellCode: "zzs_8_4_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			},
			{
				title_one: '总机构一般货物及劳务即征即退销售收入',
				title_two: '总机构一般货物及劳务即征即退分配比例',
				title_three: '总机构一般货物及劳务即征即退分配税额',
				disabledzzs_8_x_1: false,
				disabledzzs_8_x_2: false,
				disabledzzs_8_x_3: false,
				zzs_8_x_1: {
					cellCode: "zzs_8_5_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_2: {
					cellCode: "zzs_8_5_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_3: {
					cellCode: "zzs_8_5_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			},
			{
				title_one: '总机构应税服务销售收入',
				title_two: '总机构应税服务分配比例',
				title_three: '总机构应税服务分配税额',
				disabledzzs_8_x_1: false,
				disabledzzs_8_x_2: false,
				disabledzzs_8_x_3: false,
				zzs_8_x_1: {
					cellCode: "zzs_8_6_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_2: {
					cellCode: "zzs_8_6_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_3: {
					cellCode: "zzs_8_6_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			},
			{
				title_one: '总机构应税服务即征即退销售收入',
				title_two: '总机构应税服务即征即退分配比例',
				title_three: '总机构应税服务即征即退分配税额',
				disabledzzs_8_x_1: false,
				disabledzzs_8_x_2: false,
				disabledzzs_8_x_3: false,
				zzs_8_x_1: {
					cellCode: "zzs_8_7_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_2: {
					cellCode: "zzs_8_7_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				zzs_8_x_3: {
					cellCode: "zzs_8_7_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}
		],

	}
	return obj
}
